import { useQuery } from "@tanstack/react-query";
import useActiveMerchantId from "src/hooks/use-merchant-id";
import balancesProvider from "src/providers/balance-provider";

const requireMerchantId = (merchantId: string | null): string => {
	if (!merchantId) {
		throw new Error("Merchant ID is required");
	}
	return merchantId;
};

const requireBalanceId = (balanceId: string | undefined): string => {
	if (!balanceId) {
		throw new Error("Balance ID is required");
	}
	return balanceId;
};

export function useServiceFee(balanceId: string | undefined) {
	const { merchantId } = useActiveMerchantId();

	const isEnabled = Boolean(merchantId && balanceId && balanceId !== "empty");

	return useQuery({
		queryKey: ["service-fee", merchantId ?? "", balanceId ?? ""],
		queryFn: () =>
			balancesProvider.getServiceFee(
				requireMerchantId(merchantId),
				requireBalanceId(balanceId),
			),
		enabled: isEnabled,
		staleTime: 30000,
		retry: 1,
	});
}
